export class ObjectUtils {
    public static containsValue<T>(obj: Record<any, T>, value: T): value is T {
        return Object.values(obj).includes(value);
    }
    public static defaultIfAbsent<T>(obj: Record<any, T>, value: T, defaultValue: T): T {
        return ObjectUtils.containsValue(obj, value) ? value : defaultValue;
    }
}
